import keyMirror from 'keymirror';
const CALL_API = Symbol.for('Call API');

export const actions = keyMirror({
  PARTNER_WITHDRAWALS_FETCH: null,
  PARTNER_WITHDRAWALS_FETCH_SUCCESS: null,
  PARTNER_WITHDRAWALS_FETCH_FAILURE: null,
});

export function fetch(filters = {}) {
  return (dispatch) => {
    if (filters) {
      const stateFilter = filters.state ? `?status=${filters.state}` : '';
      return dispatch({
        [CALL_API]: {
          types: [
            actions.PARTNER_WITHDRAWALS_FETCH,
            actions.PARTNER_WITHDRAWALS_FETCH_SUCCESS,
            actions.PARTNER_WITHDRAWALS_FETCH_FAILURE,
          ],
          endpoint: `/withdrawals${stateFilter}`,
        },
      });
    }

    return null;
  };
}
